import AppCard from '@nxsys/components/AppCard';
import AppTagStatus from '@nxsys/components/AppTagStatus';
import { PaymentFrequencyEnum } from '@nxsys/constants/AppEnums';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { TimesheetGroupingDataItem } from '@nxsys/types/models/timesheet';
import { getTaxMonthByTaxWeek } from '@nxsys/utils/taxYear';
import { Space, Typography } from 'antd';
import moment from 'moment';
import { useCallback } from 'react';
import { useTheme } from 'styled-components';

type TimesheetGroupCardProps = {
  data: TimesheetGroupingDataItem;
  onClick: (data: TimesheetGroupingDataItem) => void;
};

const TimesheetGroupCard = ({ data, onClick }: TimesheetGroupCardProps) => {
  const { messages } = useTypedIntl();
  const theme = useTheme();

  const handleClick = useCallback(() => {
    onClick(data);
  }, [data, onClick]);

  return (
    <AppCard
      className="p-4 cursor-pointer"
      onClick={handleClick}
      style={{
        border: `1px solid ${theme.palette.primary[500]}`,
      }}
    >
      <div className="flex items-center justify-between">
        <Space direction="vertical" size={0}>
          <Typography.Title level={5}>{`${data.payFrequencyLabel} ${messages['common.period']} ${
            data.payFrequency === PaymentFrequencyEnum.MONTHLY
              ? (data.monthConfig ?? getTaxMonthByTaxWeek(data.taxPeriod) ?? data.taxPeriod)
              : data.taxPeriod
          }`}</Typography.Title>
          <Typography.Text style={{ color: theme.palette.text.secondary }}>
            {`${moment(data.startOn).format('DD MMM')} - ${moment(data.endOn).format('DD MMM')}`}
          </Typography.Text>
        </Space>
        <Space size={4}>
          {data.countSubcontractors && data.countSubcontractors > 0 ? (
            <AppTagStatus className="New">{`${data.countSubcontractors} Salaried Employee${data.countSubcontractors > 1 ? 's' : ''}`}</AppTagStatus>
          ) : null}
          {data.countTimesheets > 0 ? (
            <AppTagStatus className="New">{`${data.countTimesheets} Timesheet Employee${data.countTimesheets > 1 ? 's' : ''}`}</AppTagStatus>
          ) : null}
        </Space>
      </div>
    </AppCard>
  );
};

export default TimesheetGroupCard;
